import React from 'react'

import './index.scss'

export default function Process(props) {
  let { descs, activeIndex } = props
  return (<div className={`Process ${descs.length == 3 ? 'process3':''}`}>
    {descs.map((ele, index) => (<div key={index} className={"item" + (activeIndex >= index ? ' active' : '')}>
      <section className="dot">{index + 1}</section>
      <section className="desc">{ele}</section>
    </div>))}
  </div>)
}